import React, { useEffect, useState, useMemo, useRef } from 'react';
import moment from 'moment';

import { mergeStyleSets } from '@fluentui/react';

import { DateFieldBase } from './DateField';
import { TimeFieldBase } from './TimeField';

import * as DT from './dateTimeUtils';


const classNames = mergeStyleSets({
  dateTime: {
    width: '100%',
  }
});



export function DateTimeField(props) {
  return (
    <DT.WithPicker
      component={DateTimeFieldBase}
      componentProps={props}
      converterProps={{ formatString: DT.Format.DateTime, errorString: DT.Errors.Time }}
    />
  );
}


export function DateTimeFieldBase({ value /* moment */, error, substitution, onChange, ...restProps }) { 
  const lastRef = useRef({ date: value, time: value });
  const invalid = useMemo(() => moment.invalid(), []);

  const { date, time } = !substitution && value.isValid()
    ? DT.splitMoment(value)
    : lastRef.current;

  function handleDateChange(newValue) {
    lastRef.current.date = newValue;
    handleChange();
  }

  function handleTimeChange(newValue) {
    lastRef.current.time = newValue;
    handleChange();
  }

  function handleChange(error) {
    const { date, time } = lastRef.current;
    if (date.isValid() && time.isValid()) {
      const value = DT.mergeMoments(date, time);
      onChange(value);
    }
    else {
      onChange(invalid)
    }
  }

  const { disabled } = restProps;
  const dateDisabled = disabled;
  const timeDisabled = disabled || substitution;

  return (
    <div className={classNames.dateTime} >
      <DateFieldBase
        value={date}
        substitution={substitution}
        disabled={dateDisabled}
        onChange={handleDateChange}
      />
      <TimeFieldBase
        value={time}
        error={error}
        substitution={substitution}
        disabled={timeDisabled}
        onChange={handleTimeChange}
      />
    </div>
  );
}
